import type { CharacterDef } from '../core/types';
import { mixColor } from '../core/math';

/**
 * Rajzolt karakterportré (nem fotó): a karakter színei, járműve és személyisége
 * alapján készül, így nincs szükség külső képfájlokra.
 */
export function drawPortrait(ctx: CanvasRenderingContext2D, character: CharacterDef, size: number): void {
  const s = size / 100;
  const c = character.colors;
  const id = character.id;
  const dark = mixColor(c.body, '#0b0e15', 0.55);

  ctx.save();
  ctx.scale(s, s);
  ctx.clearRect(0, 0, 100, 100);

  // háttér
  const bg = ctx.createRadialGradient(50, 26, 6, 50, 50, 62);
  bg.addColorStop(0, mixColor(c.body, '#1b2230', 0.25));
  bg.addColorStop(1, dark);
  ctx.fillStyle = bg;
  ctx.beginPath();
  ctx.arc(50, 50, 48, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = c.accent;
  ctx.lineWidth = 3;
  ctx.stroke();

  // váll
  ctx.fillStyle = c.body;
  ctx.beginPath();
  ctx.ellipse(50, 98, 35, 23, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = c.accent;
  ctx.fillRect(41, 78, 18, 8);

  // nyak
  ctx.fillStyle = c.skin;
  ctx.fillRect(43, 62, 14, 15);

  // haj / sisak hátul
  if (id === 'boroka' || id === 'krisztina') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.ellipse(50, 52, 25, 28, 0, 0, Math.PI * 2);
    ctx.fill();
  }

  // fej
  ctx.fillStyle = c.skin;
  ctx.beginPath();
  ctx.ellipse(50, 48, 20, 23, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = 'rgba(0,0,0,0.08)';
  ctx.beginPath();
  ctx.ellipse(50, 60, 13, 6, 0, 0, Math.PI * 2);
  ctx.fill();

  // fül
  ctx.fillStyle = c.skin;
  ctx.beginPath();
  ctx.arc(29, 49, 4, 0, Math.PI * 2);
  ctx.arc(71, 49, 4, 0, Math.PI * 2);
  ctx.fill();

  // haj / sapka / sisak
  if (id === 'soma') {
    ctx.fillStyle = c.accent;
    ctx.beginPath();
    ctx.arc(50, 37, 21, Math.PI, 0);
    ctx.fill();
    ctx.fillRect(28, 36, 44, 5);
    ctx.fillStyle = mixColor(c.accent, '#000000', 0.25);
    ctx.fillRect(54, 39, 24, 6);
  } else if (id === 'boroka') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.arc(50, 34, 21, Math.PI, 0);
    ctx.fill();
    // napszemüveg
    ctx.fillStyle = '#1a1d24';
    ctx.fillRect(34, 43, 14, 8);
    ctx.fillRect(52, 43, 14, 8);
    ctx.fillRect(47, 45, 6, 3);
  } else if (id === 'anya') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.arc(50, 33, 21, Math.PI, 0);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(50, 24, 9, 0, Math.PI * 2);
    ctx.fill();
    // szemüveg
    ctx.strokeStyle = '#2a2f38';
    ctx.lineWidth = 2;
    ctx.strokeRect(34, 44, 14, 8);
    ctx.strokeRect(52, 44, 14, 8);
    ctx.beginPath();
    ctx.moveTo(48, 48);
    ctx.lineTo(52, 48);
    ctx.stroke();
  } else if (id === 'apa') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.arc(50, 34, 21, Math.PI, 0);
    ctx.fill();
    ctx.fillStyle = c.hair;
    ctx.fillRect(40, 58, 20, 4);
  } else if (id === 'robi') {
    ctx.fillStyle = c.accent;
    ctx.beginPath();
    ctx.arc(50, 40, 25, Math.PI, 0);
    ctx.fill();
    ctx.fillStyle = '#9fd8ef';
    ctx.beginPath();
    ctx.ellipse(50, 45, 19, 9, 0, 0, Math.PI);
    ctx.fill();
  } else if (id === 'gabor') {
    ctx.fillStyle = '#3a4a5a';
    ctx.beginPath();
    ctx.arc(50, 36, 22, Math.PI, 0);
    ctx.fill();
    ctx.fillRect(28, 35, 46, 5);
    ctx.fillStyle = c.accent;
    ctx.fillRect(56, 38, 22, 5);
  } else if (id === 'tibi') {
    ctx.fillStyle = 'rgba(255,255,255,0.12)';
    ctx.beginPath();
    ctx.arc(50, 30, 18, Math.PI, 0);
    ctx.fill();
    ctx.fillStyle = '#11141a';
    ctx.fillRect(33, 43, 16, 9);
    ctx.fillRect(51, 43, 16, 9);
    ctx.fillRect(47, 46, 6, 3);
  } else if (id === 'bela') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.arc(50, 33, 20, Math.PI, 0);
    ctx.fill();
    ctx.strokeStyle = '#5b5f66';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(41, 48, 7, 0, Math.PI * 2);
    ctx.arc(59, 48, 7, 0, Math.PI * 2);
    ctx.stroke();
  } else if (id === 'krisztina') {
    ctx.fillStyle = c.hair;
    ctx.beginPath();
    ctx.arc(50, 33, 21, Math.PI, 0);
    ctx.fill();
    ctx.fillStyle = '#ffc857';
    ctx.beginPath();
    ctx.arc(30, 56, 2.4, 0, Math.PI * 2);
    ctx.arc(70, 56, 2.4, 0, Math.PI * 2);
    ctx.fill();
  }

  // szemek
  ctx.fillStyle = '#22262e';
  ctx.beginPath();
  ctx.arc(42, 49, 2.1, 0, Math.PI * 2);
  ctx.arc(58, 49, 2.1, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = 'rgba(255,255,255,0.8)';
  ctx.beginPath();
  ctx.arc(42.7, 48.3, 0.7, 0, Math.PI * 2);
  ctx.arc(58.7, 48.3, 0.7, 0, Math.PI * 2);
  ctx.fill();

  // száj: agresszívabb karaktereknél szélesebb mosoly
  const grin = id === 'soma' || id === 'robi' || id === 'tibi';
  ctx.strokeStyle = '#8a4a3a';
  ctx.lineWidth = 1.8;
  ctx.beginPath();
  ctx.arc(50, 58, grin ? 7 : 5, 0.15 * Math.PI, 0.85 * Math.PI);
  ctx.stroke();

  ctx.restore();
}

/** Data URL a DOM-os portrékhoz (menü, beszólás). */
export function portraitDataUrl(character: CharacterDef, size = 96): string {
  if (typeof document === 'undefined') return '';
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';
  drawPortrait(ctx, character, size);
  return canvas.toDataURL('image/png');
}
